import { Link, useParams } from 'react-router';

interface OrdersDrilldownCampaignCellProps {
  campaign: {
    id: string;
    name: string;
    notificationTitle: string | null;
  } | null;
}

/** Origin campaign (linked) with the push title below, or a dash when none. */
export function OrdersDrilldownCampaignCell({
  campaign,
}: OrdersDrilldownCampaignCellProps) {
  const { tenantSlug } = useParams();

  if (campaign === null) return <span>—</span>;

  return (
    <div className="max-w-[200px]">
      <Link
        to={`/${tenantSlug}/campaigns/${campaign.id}`}
        className="font-medium text-primary underline-offset-4 hover:underline"
      >
        {campaign.name}
      </Link>
      {campaign.notificationTitle?.trim() ? (
        <div className="text-xs text-muted-foreground break-words">
          {campaign.notificationTitle}
        </div>
      ) : null}
    </div>
  );
}
